<p>
  Prezado Gestor, <br />
  Atenção para os horários limites de boletagem:
</p>
<!-- <table class="table table-striped">
  <thead class="thead-dark">
    <th scope="col">Tipo de Operação</th>
    <th scope="col">Gestor</th>
    <th scope="col">Fundo</th>
    <th scope="col">Horário Limite</th>
  </thead>
  <tbody>
    <tr *ngFor="let item of resume">
      <td>{{ item.ticketCutoffType }}</td>
      <td>{{ item.accountManagerName }}</td>
      <td>{{ item.fundName }}</td>
      <td>
        <span [class.out-of-vigor]="item.currentLimitTime">{{ item.defaultLimitTime | date:'HH:mm':'-0300' }}</span>
        <span *ngIf="item.currentLimitTime">&nbsp;{{ item.currentLimitTime | date:'HH:mm':'-0300' }} </span>
        <i class="fas fa-info-circle info-warning" title="Horário válido somente para o dia vigente." *ngIf="item.currentLimitTime && item.hasAccountManagerFundDefault"></i>
        <i class="fas fa-info-circle info-warning" title="Abertura de horário válida no dia apenas para o fundo selecionado, demais fundos permanecem com o horário padrão." *ngIf="item.currentLimitTime && !item.hasAccountManagerFundDefault && item.fundId"></i>
        <i class="fas fa-info-circle info-warning" title="Horário válido somente para todos os fundos, para o dia vigente." *ngIf="item.currentLimitTime && !item.hasAccountManagerFundDefault && !item.fundId"></i>
      </td>
    </tr>
  </tbody>
</table> -->
<app-cutoff [isIndex]="true"></app-cutoff>
<p>
  Em caso de dúvidas e problemas na boletagem entrar em contato com a área de
  suporte:
  <br />
  <fa-icon [icon]="faEnvelopeSquare"></fa-icon>
  <a [href]="email_href_type + email">{{ email }}</a>
  <br />
  <fa-icon [icon]="faPhoneSquare"></fa-icon>
  <a [href]="tel_href_type + phone">{{ phone }}</a>
</p>
